(function(){
    'use strict'

    angular
    .module('app.cantidadesDestajo')
    .controller('CantidadesDestajo', CantidadesDestajo);

    CantidadesDestajo.$inject = ['$q', '$window', '$scope', '$animationsSrv', 'CantidadesDestajoService', 'logger', '$location', 'UserInfoService', 'TiposPlanillaService', 'CalendarizacionesService', 'PuestosService', 'DepartamentosService', 'apiSettings', 'CantidadesService', 'BloqueoXUsuarioService', 'ProcesarPlanillaService'];

    function CantidadesDestajo($q, $window, $scope, $animationsSrv, CantidadesDestajoService, logger, $location, UserInfoService, TiposPlanillaService, CalendarizacionesService, PuestosService, DepartamentosService, apiSettings, CantidadesService, BloqueoXUsuarioService, ProcesarPlanillaService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        var searchKey = "Cantidades_Destajo_Search_Criteria";
        var ESTADO_GUARDANDO = true;

        vm.tiposPlanilla = [];
        vm.planillas = [];
        vm.puestos = [];
        vm.departamentos = [];
        vm.tipos = [];

        vm.details = [];
        vm.siguienteCorteModel = {};
        vm.verDetalle = false;

        vm.title = 'CantidadesDestajo';

        vm.cantidadDestajo = {
            tipoPlanillaId: -1,
            calendarizacionId: -1,
            departamentoId: -1,
            puestoId: -1,
            nombre: '',
            identificacion: '',
            companiaId: UserInfoService.getCompaniaId()
        };



        vm.encabezado = {
            id: 0,
            cantidadId: -1,
            fecha: moment().toDate(),
            corte: 1,
            observaciones: '',
            companiaId: UserInfoService.getCompaniaId(),
            totalCorte: 0
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        vm.fechaOptions = {
            showWeeks: true
        };

        vm.openFecha = function(){
            vm.fechaOpened = !vm.fechaOpened;
        };

        vm.fechaChanged = function(){

            if($scope.encabezadoForm.$valid)
            {
                getInfoSiguienteCorte().then(function(){
                    vm.encabezado.corte = vm.siguienteCorteModel.cortes[vm.siguienteCorteModel.cortes.length - 1].toString();
                });
            }

        };

        vm.corteChanged = function(){

            if($scope.encabezadoForm.$valid)
            {
                //Obtiene el encabezado
                var encabezado = vm.siguienteCorteModel.encabezados.find(function(e) {
                    return e.corte == vm.encabezado.corte && e.cantidadId == vm.encabezado.cantidadId;
                });

                if(encabezado != null && encabezado != undefined)
                {
                    ESTADO_GUARDANDO = false;

                    if(encabezado)
                    {
                        vm.encabezado.observaciones = encabezado.observaciones;
                    }

                    for (let index = 0; index < vm.details.length; index++) {
                        const element = vm.details[index];

                        var item = vm.siguienteCorteModel.detalle.find(function(e) {
                            return e.empleadoId == element.id && e.encabezadoId == encabezado.id;
                        });

                        if(item != null)
                        {
                            element.cantidadEditar = item.cantidad;
                        }
                        
                    }

                    vm.encabezado.totalCorte = vm.siguienteCorteModel.detalle.filter( function(el) {return el.encabezadoId == encabezado.id; }).reduce(function(acc, obj){ return acc + obj.cantidad; }, 0);
                }
                else{
                    ESTADO_GUARDANDO = true;

                    vm.encabezado.observaciones = '';
                    vm.encabezado.totalCorte = 0;

                    for (let index = 0; index < vm.details.length; index++) {
                        const element = vm.details[index];

                        element.cantidadEditar = 0;
                        
                    }
                }
            }

        };

        vm.tipoPlanillaChange = function(tipoPlanillaId){
            if(tipoPlanillaId !== -1){
                $scope.cantidadDestajoForm.tipoPlanillaId.$setValidity("different", true);
                var tipoPlanilla = vm.tiposPlanilla.find(function(tipo) {
                    return tipo.id == tipoPlanillaId;
                });

                vm.cantidadDestajo.tipoPlanillaId = tipoPlanilla.id.toString();
                vm.cantidadDestajo.calendarizacionId = -1;
                limpiarTodo();
                getAllCalendarizaciones();          
            }
            else{
                if(tipoPlanillaId != null){
                    vm.planillas = [];
                    $scope.cantidadDestajoForm.tipoPlanillaId.$setValidity("different", false);                    
                }
            }
        };

        vm.tipoCantidadChange = function(cantidadId){
            if(cantidadId !== -1){
                $scope.encabezadoForm.cantidadId.$setValidity("different", true);

                getInfoSiguienteCorte().then(function(){
                    vm.encabezado.corte = vm.siguienteCorteModel.cortes[vm.siguienteCorteModel.cortes.length - 1].toString();
                });         
            }
            else{
                if(cantidadId != null){
                    $scope.encabezadoForm.cantidadId.$setValidity("different", false);                    
                }
            }
        };

        vm.planillaChange = function(planillaId){
            if(planillaId !== -1){
                $scope.cantidadDestajoForm.planillaId.$setValidity("different", true);
                vm.planilla = vm.planillas.find(function(p) {
                    return p.id == planillaId;
                });
                limpiarTodo();
                vm.search();
            }
            else{
                if(planillaId != null){
                    $scope.cantidadDestajoForm.planillaId.$setValidity("different", false);                    
                }
            }
        };


        var promiseTipoPlanilla = getTiposPlanilla();
        var promisePuestos = getPuesto();
        var promiseDepartamento = getDepartamento();
        getTipos();

        CargarPreviousSearch();

        function CargarPreviousSearch(){
            var previousSearch = UserInfoService.getDataFromSessionStorage(searchKey);
            if(previousSearch){
                vm.cantidadDestajo = previousSearch;
                $q.all([promiseTipoPlanilla, promisePuestos, promiseDepartamento]).then(function(){

                    var promiseCalendarizaciones = getAllCalendarizaciones();
                    $q.all([promiseCalendarizaciones]).then(vm.search);
                });               
            }

        }

        function getPuesto(){
            var promise = PuestosService.getAll()
            .then(function(puestos){
                vm.puestos = puestos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los puestos.');
            }); 
            
            return promise;
        };

        function getDepartamento(){
            var promise = DepartamentosService.getAll(UserInfoService.getCompaniaId())
            .then(function(departamentos){
                vm.departamentos = departamentos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los departamentos.');
            }); 
            
            return promise;
        };

        function getTiposPlanilla(){
            var promise = TiposPlanillaService.getAllForCalendarizacion(UserInfoService.getCompaniaId())
            .then(function(tiposPlanilla){
                tiposPlanilla.forEach(tipo => {
                    tipo.fechaInicio = moment(tipo.fechaInicio).toDate();
                    tipo.fechaFinal = moment(tipo.fechaFinal).toDate();
                });
                vm.tiposPlanilla = tiposPlanilla;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos de planilla.');
            }); 
            
            return promise;
        };

        function getTipos(){
            var promise = CantidadesService.getAllDestajo()
            .then(function(tipos){
                vm.tipos = tipos;
            })
            .catch(function(error){
                $logger.error('Error al obtener los tipos.');
            }); 
            
            return promise;
        };

        function getAllCalendarizaciones(){

            var promise = CalendarizacionesService.getAllAbiertasProcesando(UserInfoService.getCompaniaId(), vm.cantidadDestajo.tipoPlanillaId);

            promise
            .then(function(calendarizaciones){
                calendarizaciones.forEach(calendarizacion => {
                    calendarizacion.fechaInicio = moment(calendarizacion.fechaInicio).toDate();
                    calendarizacion.fechaFinal = moment(calendarizacion.fechaFinal).toDate();
                });
                vm.planillas = calendarizaciones;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener las Planillas.');
                        break;
                }
                
            });

            return promise;
        };

        function getInfoSiguienteCorte(){

            var strFecha = moment(vm.encabezado.fecha).format('YYYY-MM-DD');
            var promise = CantidadesDestajoService.getSiguienteCorte(UserInfoService.getCompaniaId(), vm.cantidadDestajo.calendarizacionId, vm.encabezado.cantidadId, strFecha);

            promise
            .then(function(siguienteCorteModel){
                console.log(siguienteCorteModel);

                vm.siguienteCorteModel =  siguienteCorteModel;


                ESTADO_GUARDANDO = true;

                vm.encabezado.observaciones = '';
                vm.encabezado.totalCorte = 0;

                for (let index = 0; index < vm.details.length; index++) {
                    const element = vm.details[index];

                    element.cantidadEditar = 0;
                    
                }

            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener las Planillas.');
                        break;
                }
                
            });

            return promise;
        };

        function validateTipoPlanilla(){
            if(vm.cantidadDestajo.tipoPlanillaId == -1){
                $scope.cantidadDestajoForm.tipoPlanillaId.$setValidity("different", false);
            }
            else{
                $scope.cantidadDestajoForm.tipoPlanillaId.$setValidity("different", true);
            }
        };

        function validatePlanilla(){
            if(vm.cantidadDestajo.calendarizacionId == -1){
                $scope.cantidadDestajoForm.planillaId.$setValidity("different", false);
            }
            else{
                $scope.cantidadDestajoForm.planillaId.$setValidity("different", true);
            }
        };

        function validateTipoCantidad(){
            if(vm.encabezado.cantidadId == -1){
                $scope.encabezadoForm.cantidadId.$setValidity("different", false);
            }
            else{
                $scope.encabezadoForm.cantidadId.$setValidity("different", true);
            }
        };

        function doFormValidations(){
            validateTipoPlanilla();
            validatePlanilla();
        };

        vm.search = function() {

            $scope.submitted = true;
            doFormValidations();

            if(!$scope.cantidadDestajoForm.$valid){
                return;
            }

            var promise = CantidadesDestajoService.getAll(vm.cantidadDestajo);

            promise
            .then(function(cantidadesDestajo){
                UserInfoService.saveDataOnSessionStorage(searchKey, vm.cantidadDestajo);
                vm.details = cantidadesDestajo.data;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los datos.');
                        break;
                }
            });
        };

        function doFormEncabezadoValidations(){
            doFormValidations();
            validateTipoCantidad();
        };

        vm.save = function(){

            $scope.submitted = true;

            doFormEncabezadoValidations();
            doFormValidations();

            if($scope.cantidadDestajoForm.$valid && $scope.encabezadoForm.$valid){
                if(ESTADO_GUARDANDO){
                    saveCantidad();
                }
                else{
                    updateCantidad();
                }
            }     
        
        };

        function  limpiarTodo(){
            limpiarDatos();
            vm.details = [];
        }

        function limpiarDatos(){
            ESTADO_GUARDANDO = true;
            vm.encabezado.cantidadId = -1;
            vm.encabezado.fecha = moment().toDate();
            vm.encabezado.observaciones = '';
            vm.encabezado.totalCorte = 0;

            for (let index = 0; index < vm.details.length; index++) {
                const element = vm.details[index];

                element.cantidadEditar = 0;
                
            }

        };

        function transformData(){

            var encabezado = Object.assign({}, vm.encabezado);
            encabezado.fecha = moment(encabezado.fecha).format('YYYY-MM-DD');
            encabezado.calendarizacionId = vm.cantidadDestajo.calendarizacionId;

            var detalle = [];

            vm.details.forEach(element => {
                detalle.push({
                    empleadoId: element.id,
                    cantidad: element.cantidadEditar
                });
            });

            return {
                encabezado: encabezado,
                detalle: detalle
            }
        }

        function saveCantidad() {
            
            var data = transformData();

            var promise = CantidadesDestajoService.save(data);
            
            promise
            .then(function(response){
                logger.success('Cantidades Destajo creadas con éxito.');
                limpiarDatos();
                vm.search();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear las cantidades: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateCantidad(){

            var data = transformData();

            var promise = CantidadesDestajoService.update(data);
            
            promise
            .then(function(response){
                logger.success('Cantidades modificadas con éxito.');
                limpiarDatos();
                vm.search();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar las cantidades: ' + error.data.Message);
                        break;
                }
            });   
        };

        vm.getTotal = function(detalle){

            return detalle.reduce(function(acc, obj){ return acc + obj.cantidad; }, 0);
        };

        vm.onDocumentKeyDown = function(event){
            if(event.which === 113)
            {
                $animationsSrv.scrollToTop();
                vm.save();
            }
        };

        document.onkeydown = vm.onDocumentKeyDown;

        vm.recalcular = function() {

            $scope.submitted = true;
            doFormValidations();

            if(!$scope.cantidadDestajoForm.$valid){
                $animationsSrv.scrollToTop();
                return;
            }

            var calendarizacion = vm.planillas.find(function(c) {
                return c.id == vm.cantidadDestajo.calendarizacionId;
            });

            if(calendarizacion.estado==1)
            {
                logger.error('La planilla debe estar en estado PROCESANDO para el recálculo');
                return;
            }

            var promise = BloqueoXUsuarioService.getBloqueoXCalendarizacion(calendarizacion.id);

            promise
            .then(function(bloqueo){
                if(bloqueo){
                    logger.warning(`La planilla esta bloqueada por: ${bloqueo.usuarioNombreCompleto}`);
                }
                else{
                    var promise = ProcesarPlanillaService.recalcular(calendarizacion);
                
                    promise
                    .then(function(response){
                        vm.goToPlanillaProcesada(calendarizacion);
                        logger.success('Planilla procesada con éxito.');
                    })
                    .catch(function(error){
                        switch (error.status) {
                            case 500:
                            logger.error(`Hubo un error al procesar la planilla: ${error.data.Message}`);
                                break;
                        
                            default:
                                logger.error('Hubo un error al procesar la planilla');
                                break;
                        }
                    }); 
                }
            })
            .catch(function(error){
                $logger.error('Error al verificar bloqueos. ');
            });
        };
        
        vm.goToPlanillaProcesada = function(calendarizacion){
            
            var path = '/planillaProcesada/';

            if(calendarizacion){

                var promise = BloqueoXUsuarioService.getBloqueoXCalendarizacion(calendarizacion.id);

                promise
                .then(function(bloqueo){
                    if(bloqueo){
                        logger.warning(`La planilla esta bloqueada por: ${bloqueo.usuarioNombreCompleto}`);
                    }
                    else{
                        $location.path(path + calendarizacion.id);
                    }
                })
                .catch(function(error){
                    $logger.error('Error al verificar bloqueos. ');
                });
            }
            else{
                logger.error('No fue posible cargar los datos de la planilla procesada');
            }
            
        };

    }
})();